import React, { useState } from 'react';
import { connect } from 'react-redux';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import TextInput from '../../../../Shared/TextInput/TextInput';
import { getCustomerNvOrgListAsync } from '../../BusinessMonitoringChartsAsyncThunk';

const Search = (props) => {
    const [searchKey, setSearchKey] = useState('');

    return (
        <div className='search-container'>
            <form noValidate id='search' onSubmit={(e)=> e.preventDefault()}>
                <TextInput
                    value={searchKey}
                    error={''}
                    placeholder='הכנס קוד קו/NV'
                    id='txt-search'
                    name='txt-search'
                    type='text'
                    maxLength='40'
                    autoComplete='off'
                    onChange={(e) => setSearchKey(e.target.value)}
                />
                <BtnSubmit text={'הצג נתונים'} onclick={handleSearchClick} formid='search' />            
            </form>
        </div>
    );

    function handleSearchClick() {
        props.getCustomerNvOrgListAsync({ searchKey: searchKey });
    }

}

const mapStateToProps = (state) => {
    return {
        isAdminMode: state.businessMonitoringChartsBlock.isAdminMode
    };
};
  
const mapDispatchToProps = { getCustomerNvOrgListAsync };
  
export default connect(mapStateToProps, mapDispatchToProps)(Search);